

const statuses = ["draft", "sent", "approved", "rejected", "expired"];

interface QuotationAdditionalDetailsProps {
  status: string;
  notes: string;
  onStatusChange: (value: string) => void;
  onNotesChange: (value: string) => void;
}

export default function QuotationAdditionalDetails({
  status,
  notes,
  onStatusChange,
  onNotesChange,
}: QuotationAdditionalDetailsProps) {
  return (
    <div className="bg-white border border-stone-200 rounded-xl p-4 sm:p-5">
      <h3 className="text-sm font-semibold text-stone-700 mb-4">Additional Details</h3>
      <div className="space-y-4">
        <div>
          <label className="block text-xs font-medium text-stone-600 mb-2">Status</label>
          <div className="flex gap-2 flex-wrap">
            {statuses.map(s => (
              <button
                key={s}
                type="button"
                onClick={() => onStatusChange(s)}
                className={`px-3 py-1.5 rounded-lg text-xs font-medium transition-colors ${
                  status === s
                    ? "bg-amber-100 text-amber-700 border border-amber-200"
                    : "bg-stone-50 text-stone-600 border border-stone-200 hover:bg-stone-100"
                }`}
              >
                {s.charAt(0).toUpperCase() + s.slice(1)}
              </button>
            ))}
          </div>
        </div>

        <div>
          <label className="block text-xs font-medium text-stone-600 mb-1.5">Notes</label>
          <textarea
            value={notes}
            onChange={(e) => onNotesChange(e.target.value)}
            placeholder="Additional details..."
            rows={3}
            className="w-full px-3 py-2 rounded-lg border border-stone-200 text-sm focus:border-amber-400 focus:ring-2 focus:ring-amber-100 outline-none resize-none"
          />
        </div>
      </div>
    </div>
  );
}
